import React from 'react';
import ParticleBackground from './ParticleBackground';

interface SplashPageProps {
  onEnter: () => void;
}

const SplashPage: React.FC<SplashPageProps> = ({ onEnter }) => {
  return (
    <div className='min-h-screen bg-background-light dark:bg-background-dark flex items-center justify-center relative overflow-hidden'>
      {/* Animated gradient background - same as main app */}
      <div
        className='fixed inset-0 overflow-hidden'
        style={{
          zIndex: 0,
          backgroundColor: '#ffffff',
          pointerEvents: 'none',
        }}
      >
        <div className='absolute w-full h-full opacity-55'>
          {/* Multiple overlapping radial gradients to create mesh effect */}
          <div
            className='absolute w-full h-full'
            style={{
              background: `
                radial-gradient(circle at 20% 20%, #2A7B9B 0%, transparent 50%),
                radial-gradient(circle at 80% 20%, #57C785 0%, transparent 50%),
                radial-gradient(circle at 20% 80%, #EDDD53 0%, transparent 50%),
                radial-gradient(circle at 50% 50%, #2A7B9B 0%, transparent 60%)
              `,
              animation: 'gradient-shift 20s ease infinite',
            }}
          />
          <div
            className='absolute w-full h-full'
            style={{
              background: `
                radial-gradient(circle at 40% 10%, #EDDD53 0%, transparent 40%),
                radial-gradient(circle at 90% 40%, #57C785 0%, transparent 45%),
                radial-gradient(circle at 60% 90%, #2A7B9B 0%, transparent 45%),
                radial-gradient(circle at 70% 30%, #57C785 0%, transparent 35%)
              `,
              animation: 'gradient-shift 25s ease infinite reverse',
            }}
          />
          <div
            className='absolute w-full h-full'
            style={{
              background: `
                radial-gradient(circle at 85% 15%, #EDDD53 0%, transparent 35%),
                radial-gradient(circle at 35% 85%, #2A7B9B 0%, transparent 40%),
                radial-gradient(circle at 65% 65%, #57C785 0%, transparent 30%)
              `,
              animation: 'gradient-shift 30s ease infinite',
            }}
          />
        </div>
      </div>

      {/* Particles layer */}
      <ParticleBackground isDark={false} />

      {/* Content */}
      <div className='text-center p-8 relative z-10'>
        <h1 className='text-6xl font-bold text-text-primary-light dark:text-text-primary-dark mb-4'>
          GameChanger
        </h1>
        <p className='text-xl text-text-secondary-light dark:text-text-secondary-dark mb-12'>
          Your edge in betting
        </p>
        <button
          onClick={onEnter}
          className='inline-flex items-center justify-center px-8 py-4 text-lg font-semibold bg-surface-light/80 dark:bg-surface-dark/80 backdrop-blur-sm border border-border-light dark:border-border-dark rounded-lg text-text-primary-light dark:text-text-primary-dark hover:bg-surface-light/90 dark:hover:bg-surface-dark/90 hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#2A7B9B] focus:ring-offset-2'
        >
          Enter Application
        </button>
      </div>
    </div>
  );
};

export default SplashPage;
